import {
  stateSearchDefault,
  stateAddDatas,
  stateAddMoreDatas,
  stateAddData,
  stateUpdate,
  stateDelete,
} from '../reduxReducer'

import {
  stateAddsManyDatas,
  stateAddsManyMoreDatas,
} from '../reduxReducerV2'

import {
  ADDS,
  ADDS_MORE,
  ADD,
  UPDATE,
  REMOVE,

  ADDS_MANY,
  ADDS_MANY_MORE,
} from './BusinessesActions'


// Initial State
const initialState = {
  data: [],
  dataGroups: [],
  search: stateSearchDefault(),
}

const BusinessReducer = (state=initialState, action) => {
  const actionDatas = action.datas
  const actionData = action.data

  switch (action.type) {
    case ADDS:
      return stateAddDatas(state, action, actionDatas)

    case ADDS_MORE:
      return stateAddMoreDatas(state, action, actionDatas)

    case ADD:
      return stateAddData(state, action, actionData)

    case REMOVE:
      return stateDelete(state, action)

    case UPDATE:
      return stateUpdate(state, action, actionData)

    case ADDS_MANY:
      return stateAddsManyDatas(state, action, actionDatas)

    case ADDS_MANY_MORE:
      return stateAddsManyMoreDatas(state, action, actionDatas)

    default:
      return state
  }
}


export default BusinessReducer
